import React, { useEffect, useState } from "react";
import axios from "axios";
import { Modal, Box, Button, TextField, Grid, Typography } from "@mui/material";
import Swal from "sweetalert2";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 700,
  maxHeight: "90vh",
  overflowY: "auto",
  bgcolor: "background.paper",
  boxShadow: 24,
  borderRadius: 2,
  p: 4,
};

const formatDateTimeLocal = (date) => (date ? date.substring(0, 16) : "");

const toApiDateTime = (value) => (value ? value + ":00" : undefined);

const EditarVisita = ({
  idVisita,
  objetivo,
  actividad,
  observaciones,
  fechaInicialProp,
  fechaFinalProp,
  onSuccess,
}) => {
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  // 🔒 valores originales
  const [original, setOriginal] = useState({});

  // ✏️ formulario
  const [form, setForm] = useState({
    objetivo: "",
    actividad: "",
    observaciones: "",
    fechaInicial: "",
    fechaFinal: "",
  });

  useEffect(() => {
    if (open) {
      const initialForm = {
        objetivo: objetivo || "",
        actividad: actividad || "",
        observaciones: observaciones || "",
        fechaInicial: formatDateTimeLocal(fechaInicialProp),
        fechaFinal: formatDateTimeLocal(fechaFinalProp),
      };

      setForm(initialForm);
      setOriginal(initialForm); // 🔥 guardamos snapshot original
    }
  }, [
    open,
    objetivo,
    actividad,
    observaciones,
    fechaInicialProp,
    fechaFinalProp,
  ]);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const buildPayload = () => {
    const payload = {};

    if (form.objetivo !== original.objetivo) payload.Objetivo = form.objetivo;

    if (form.actividad !== original.actividad)
      payload.Actividad = form.actividad;

    if (form.observaciones !== original.observaciones)
      payload.Observaciones = form.observaciones;

    if (form.fechaInicial !== original.fechaInicial)
      payload.FechaInicial = toApiDateTime(form.fechaInicial);

    if (form.fechaFinal !== original.fechaFinal)
      payload.FechaFinal = toApiDateTime(form.fechaFinal);

    return payload;
  };

  const handleGuardar = async () => {
    const payload = buildPayload();

    if (Object.keys(payload).length === 0) {
      Swal.fire("Sin cambios", "No se detectaron modificaciones", "info");
      return;
    }

    try {
      setLoading(true);

      await axios.put(
        `https://suadesarrollo.azurewebsites.net/api/ActualizaVisitaEvaluador?Id=${idVisita}`,
        payload,
        {
          auth: {
            username: "BasicAuth@icontec.org",
            password: "yQLzqmR7eZSuAmQZUqhY",
          },
        },
      );

      setOpen(false);

      Swal.fire({
        icon: "success",
        title: "Actualizado",
        text: "La visita fue actualizada correctamente",
        timer: 2000,
        showConfirmButton: false,
      });

      onSuccess();
    } catch (error) {
      console.error(error);
      Swal.fire("Error", "No se pudo actualizar la visita", "error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Button size="small" variant="contained" onClick={() => setOpen(true)}>
        Editar
      </Button>

      <Modal open={open} onClose={() => setOpen(false)}>
        <Box sx={style}>
          <Typography variant="h6" mb={2} color="primary"></Typography>
          <Typography variant="h6" mb={2} color="primary">
            Editar Visita #{idVisita}
          </Typography>

          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Objetivo"
                name="objetivo"
                value={form.objetivo}
                onChange={handleChange}
                multiline
                minRows={3}
              />
            </Grid>

            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Actividad"
                name="actividad"
                value={form.actividad}
                onChange={handleChange}
                multiline
                minRows={3}
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                label="Fecha Inicial"
                type="datetime-local"
                name="fechaInicial"
                value={form.fechaInicial}
                onChange={handleChange}
                InputLabelProps={{ shrink: true }}
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                label="Fecha Final"
                type="datetime-local"
                name="fechaFinal"
                value={form.fechaFinal}
                onChange={handleChange}
                InputLabelProps={{ shrink: true }}
              />
            </Grid>

            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Observaciones"
                name="observaciones"
                value={form.observaciones}
                onChange={handleChange}
                multiline
                minRows={4}
              />
            </Grid>
          </Grid>

          <Box mt={3} display="flex" justifyContent="flex-end" gap={2}>
            <Button onClick={() => setOpen(false)}>Cancelar</Button>
            <Button
              variant="contained"
              onClick={handleGuardar}
              disabled={loading}
            >
              {loading ? "Guardando..." : "Guardar cambios"}
            </Button>
          </Box>
        </Box>
      </Modal>
    </>
  );
};

export default EditarVisita;
